//#region src/utils/styles.ts
function getPriorityVariant(priority) {
	if (priority === 3) return "critical";
	if (priority === 2) return "caution";
	if (priority === 1) return "info";
	return "";
}
//#endregion
export { getPriorityVariant };

//# sourceMappingURL=styles.js.map